/** AP09 copy (one group per control; a ticket edits only its own file). */
export const ap09PtBr = {
  title: 'Despesas antecipadas e diferimentos',
  description: 'Cronogramas de apropriação de despesas antecipadas em dia.',
  prerequisite: '',
  detail: {
    missedInstallmentsTitle: 'Parcelas não lançadas',
    missedInstallmentsEmpty: 'Nenhuma parcela vencida sem lançamento.',
    reconciliationTitle: 'Saldo remanescente vs. contabilidade',
    reconciliationEmpty: 'Nenhuma divergência entre o cronograma e a contabilidade.',
    glAboveSchedule: 'GL acima do cronograma',
    glBelowSchedule: 'GL abaixo do cronograma',
    accountLoading: 'Carregando a conta contábil',
    accountFallback: 'Conta contábil',
    uncoveredTitle: 'Lançamentos sem cronograma nativo',
    uncoveredEmpty: 'Nenhum lançamento sem cronograma nativo.',
    uncoveredHint: 'Evidência externa não disponível — não é tratado como aprovado.',
    uncoveredAccount: 'Conta contábil de antecipação',
    openBill: 'Abrir fatura',
    unresolvedCurrency: 'Moeda funcional do livro não resolvida; comparação pendente.',
    coverageGapTitle: 'População de despesas antecipadas não comprovada',
    coverageReasons: {
      NO_PROVISIONED_PREPAID_SOURCE:
        'Nenhum diferimento efetivo até a data de corte identificou as contas antecipadas deste livro. Confirme a população de contas e revise os cronogramas externos do período.',
    },
    coverageScope: {
      entity: 'Entidade',
      book: 'Livro',
      period: 'Período',
      cutoff: 'Data de corte',
    },
  },
};

export const ap09En: typeof ap09PtBr = {
  title: 'Prepaid expenses and deferrals',
  description: 'Prepaid expense amortization schedules up to date.',
  prerequisite: '',
  detail: {
    missedInstallmentsTitle: 'Installments not posted',
    missedInstallmentsEmpty: 'No due installment without a posting.',
    reconciliationTitle: 'Remaining balance vs. GL',
    reconciliationEmpty: 'No difference between the schedule and the GL.',
    glAboveSchedule: 'GL above schedule',
    glBelowSchedule: 'GL below schedule',
    accountLoading: 'Loading the GL account',
    accountFallback: 'GL account',
    uncoveredTitle: 'Postings with no native schedule',
    uncoveredEmpty: 'No postings without a native schedule.',
    uncoveredHint: 'External evidence unavailable — not treated as passed.',
    uncoveredAccount: 'Prepaid GL account',
    openBill: 'Open bill',
    unresolvedCurrency: 'Book functional currency is unresolved; comparison pending.',
    coverageGapTitle: 'Prepaid expense population is unproven',
    coverageReasons: {
      NO_PROVISIONED_PREPAID_SOURCE:
        'No deferral effective by the cutoff identified this book’s prepaid accounts. Confirm the account population and review external schedules for this period.',
    },
    coverageScope: {
      entity: 'Entity',
      book: 'Book',
      period: 'Period',
      cutoff: 'Cutoff date',
    },
  },
};
